import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from '_Route/Root';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './Modules';
import { composeWithDevTools } from 'redux-devtools-extension';


const store = createStore(rootReducer, composeWithDevTools())

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Root />
  </Provider>
  // </React.StrictMode>
);

